import dynamic from 'next/dynamic'
import Meta from 'components/meta/meta'
import PageHead from 'components/page-head/page-head'
import PageFoot from 'components/page-foot/page-foot'
import Faqs from 'components/faqs/faqs'
import { getData } from 'utils/api'

const Products = dynamic(() => import('components/hits/products'))

export default function Page({ name, description, ogDescription, longDescription, faqs }) {
    const filter = `all_groups:"${name}"`
    return (
        <>
            <Meta title={name} description={ogDescription} />
            <PageHead title={name} description={description} />
            <Products filter={filter} />
            <PageFoot>{longDescription}</PageFoot>
            {!!faqs?.length && <Faqs items={faqs} />}
        </>
    )
}

export async function getStaticProps(context) {
    const groups = {
        'maistas-ir-gerimai': 'Maistas ir gėrimai',
        'namai-ir-gyvenimas': 'Namai ir gyvenimas',
        'drabuziai-ir-avalyne': 'Drabužiai ir avalynė',
        'papuosalai-ir-aksesuarai': 'Papuošalai ir aksesuarai',
        'pramogos-ir-zaislai': 'Pramogos ir žaislai'
    }

    const ogDescriptions = {
        'maistas-ir-gerimai':
            'Skatiname žmones mėgautis maistu nepamirštant pasirūpinti savo sveikata. Įsigykite, ko trokštate - viskas nuo ekologiškų produktų iki namų gamybos desertų.',
        'namai-ir-gyvenimas':
            'Vietiniai gamintojai supranta lietuviškų namų sampratą ir gamina produktus, kurie praturtins jūsų kasdienį gyvenimą ir sušildys jūsų namų atmosferą.',
        'drabuziai-ir-avalyne':
            'Lietuviskapreke.lt parduotuvėse atrasite pačius madingiausius drabužius ir avalynę. Išsirinkite unikaliausiius produktus, atitinkančius jūsų stilių.',
        'papuosalai-ir-aksesuarai':
            'Norite praturtinti savo stilių smulkiomis detalėmis ir rankų darbu papuošalais? Atraskite Lietuvoje pagamintus papuošalus ir kitus aksesuarus.',
        'pramogos-ir-zaislai':
            'Gausybė rankų darbo žaislų ir kitų smulkmenų, kurios nuspalvins jūsų gyvenimą naujomis spalvomis.'
    }

    const descriptions = {
        'maistas-ir-gerimai':
            'Lietuviskapreke.lt skatina žmones mėgautis maistu nepamirštant pasirūpinti savo sveikata. Čia rasite visko nuo ekologiškų produktų iki namų gamybos desertų. Gyvenimas jau ir taip yra nuostabus, bet kartu mes galime jį padaryti ir labai skaniu!',
        'namai-ir-gyvenimas':
            'Net pati mažiausia smulkmena gali paversti jūsų namus pačiais jaukiausiais ir gražiausiais. Mūsų vietiniai gamintojai supranta lietuviškų namų sampratą ir puikiai gamina įvairiausias <a href="https://www.lietuviskapreke.lt/">prekes namams</a>, kurios praturtins jūsų kasdienį gyvenimą ir sušildys jūsų namų atmosferą.',
        'drabuziai-ir-avalyne':
            'Mūsų drabužiai ir avalynė aplinkai parodo kas mes tokie esame ir kuo tikime. Lietuviskapreke.lt parduotuvėse atrasite pačius madingiausius drabužius ir avalynę. Leiskite sau išsiskirti su unikaliu stiliumi ir spindėkite ne tik vidumi, bet ir išore.',
        'papuosalai-ir-aksesuarai':
            'Norite praturtinti savo stilių smulkiomis detalėmis ir rankų darbu papuošalais? Pas mus atrasite įvairius, Lietuvoje pagamintus, papuošalus ir kitus aksesuarus. Nesvarbu ką ir kada mėgstate nešioti, čia tikrai atrasite tą mažą detalę, kurios ieškojote sau ar savo artimiesiems. <a href="https://www.lietuviskapreke.lt/tinklarastis-pirkejams/straipsnis/sventems-artejant-puiki-dovana-artimiesiems-ranku-darbo-papuosalai-ir-aksesuarai">Rankų darbo papuošalai</a> internetu jums ir jūsų draugams - įsigykite dabar!',
        'pramogos-ir-zaislai':
            'Ar ieškote savo vaikams naujų žaislų? O galbūt patys norite nusikelti atgal į vaikystę ir leisti sau vėl papramogauti? Peržvelkite mūsų gausybę siūlomų rankų darbo žaislų ir kitų smulkmenų, kurios nuspalvins jūsų gyvenimą naujomis spalvomis. Būti vaiku niekuomet nevėlu!'
    }

    const longDescriptions = {
        'maistas-ir-gerimai':
            'Lietuviskapreke.lt skatina žmones mėgautis maistu nepamirštant pasirūpinti savo sveikata. Čia rasite visko nuo ekologiškų produktų iki namų gamybos desertų. Gyvenimas jau ir taip yra nuostabus, bet kartu mes galime jį padaryti ir labai skaniu!',
        'namai-ir-gyvenimas':
            'Net pati mažiausia smulkmena gali paversti jūsų namus pačiais jaukiausiais ir gražiausiais. Mūsų vietiniai gamintojai supranta lietuviškų namų sampratą ir puikiai gamina įvairiausias <a href="https://www.lietuviskapreke.lt/">prekes namams</a>, kurios praturtins jūsų kasdienį gyvenimą ir sušildys jūsų namų atmosferą.',
        'drabuziai-ir-avalyne':
            'Mūsų drabužiai ir avalynė aplinkai parodo kas mes tokie esame ir kuo tikime. Lietuviskapreke.lt parduotuvėse atrasite pačius madingiausius drabužius ir avalynę. Leiskite sau išsiskirti su unikaliu stiliumi ir spindėkite ne tik vidumi, bet ir išore.',
        'papuosalai-ir-aksesuarai':
            '<p>Kiekviena stilistė ar stilinga moteris pasakytų, jog be papuošalų ir aksesuarų jūsų įvaizdis nėra užbaigtas. Net smulkiausia detalė papildys ir pagyvins jūsų dienos įvaizdį. <a href="https://www.lietuviskapreke.lt/k/papuosalai?page=1" target="_top">Rankų darbo papuošalai</a> ir aksesuarai tam puikiai tiks.</p><p>Jei mėgstate minimalizmą, galite išsirinkti tik rankų darbo aksesuarus, kurių puslapyje lietuviskapreke.lt išties gausu. Kokybiška rankinė, išskirtinė kuprinė su spauda ar odinė piniginė taps jūsų svarbiausia įvaizdžio detale. Nepamirškite ir pirkinių krepšių, jie taip pat yra svarbi įvaizdžio dalis, o be to – tvarus sprendimas.</p><p>Dar vieni labai svarbūs <a href="https://www.lietuviskapreke.lt/k/aksesuarai" target="_top">rankų darbo aksesuarai</a> – kepurės, movos bei šalikai. Juk visos norime stilingai atrodyti net ir darganotą rudenį ar šaltą žiemą. Čia galėsite išsirinkti aukštos kokybės, alpakų, merino vilnos, moheros bei šilko gaminių.</p><p><a href="https://www.lietuviskapreke.lt/k/papuosalai/kaklo-papuosalai?page=1" target="_top">Papuošalai moterims</a> taip pat yra be galo svarbūs. Kiekviena moteris svajoja savo rankas papuošti išskirtiniu žiedu ar apyranke, ausis – stilingais auskarais, o kaklą padabinti dar niekam nematytu vėriniu. Rinkitės rankų darbo dervos žiedus, kurie gali būti įvairiausių spalvų, puošti aukso dribsniais, gėlių žiedais, kvepiantys migdolais.</p><p>Rankų darbo natūralių akmenų apyrankės ne tik papuoš ranką, bet ir tiks prie bet kokio įvaizdžio, o tinkamai parinkus pagal gimimo dieną, sukurs apsaugos ir pasitikėjimo savimi aurą.</p><p>Auskarus galėsite išsirinkti nuo visai smulkių, primenančių kavos pupelę, klasikinės aukso spalvos, iki masyvių, išskirtinių medinių ar polimerinio molio lipdinių.</p><p>Iš daugybės kaklo papuošalų galėsite išsirinkti tą, kuris labiausiai atspindi jūsų asmenybę. Rafinuotoms ir elegantiškoms moterims kaklą papuoš upinių perlų ar porceliano vėriniai, kurie gali tapti puikia dovana jūsų mamai ar draugei. Gamtos mylėtojos gali pasipuošti vėriniais su inkrustuotomis uogomis ir gėlėmis, na, o linksmuolėms, šmaikščioms ir padūkusioms asmenybėms puikiai tiks pakabučiai iš perdirbtos riedlentės. Nebijokite puoštis ir tapkite išskirtinėmis!</p>',
        'pramogos-ir-zaislai':
            'Ar ieškote savo vaikams naujų žaislų? O galbūt patys norite nusikelti atgal į vaikystę ir leisti sau vėl papramogauti? Peržvelkite mūsų gausybę siūlomų rankų darbo žaislų ir kitų smulkmenų, kurios nuspalvins jūsų gyvenimą naujomis spalvomis. Būti vaiku niekuomet nevėlu!'
    }

    if (!groups[context.params.slug]) {
        return { notFound: true }
    }

    const data = await getData(`group/${context.params.slug}`)
    if (data.props && data.props.redirect) {
        return {
            redirect: {
                destination: data.props.redirect
            }
        }
    }

    return {
        ...data,
        props: {
            ...data.props,
            name: groups[context.params.slug],
            description: descriptions[context.params.slug],
            ogDescription: ogDescriptions[context.params.slug],
            longDescription: longDescriptions[context.params.slug]
        }
    }
}

export async function getStaticPaths() {
    const slugs = [
        'maistas-ir-gerimai',
        'namai-ir-gyvenimas',
        'drabuziai-ir-avalyne',
        'papuosalai-ir-aksesuarai',
        'pramogos-ir-zaislai'
    ]

    return {
        paths: slugs.map(slug => ({
            params: { slug }
        })),
        fallback: false
    }
}

// import { getData, getList } from 'utils/api'
//return getData(`group/${context.params.slug}`)
//return getList('groups-list')
